/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useMemo, useState } from 'react'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import FAQ from 'pagesNew/FAQ'
import { PracticeTestTypeEnum } from '__generatedTypes__/globalTypes'
import { DescriptionForm } from 'components/DescriptionForm'
import { usePlatformsAndSubjects } from 'hooks/usePlatformsAndSubjects'
import { PlatformSlug } from 'constants/consts'
import { NotFound } from '../../components/NotFound'
import { COMMON_PTS_CONFIG, MockExamsTabs } from './consts'
import * as classes from './styles'
import { CommonPTs } from './components/CommonPTs'

const tabs = Object.values(MockExamsTabs).map((item) => ({ id: item, title: item }))

export const List: FC<{ type?: PracticeTestTypeEnum }> = ({ type = PracticeTestTypeEnum.PracticeTest }) => {
  const config = useMemo(() => COMMON_PTS_CONFIG[type], [type])
  const availableTabs = useMemo(() => {
    const availableTabs: TabsItem[] = [tabs[0]]

    if (config?.descriptionPage) {
      availableTabs.push(tabs[1])
    }

    if (config?.faqPage) {
      availableTabs.push(tabs[2])
    }

    return availableTabs
  }, [config])
  const [activeTab, setActiveTab] = useState<TabsItem>(tabs[0])
  const { selectedPlatform } = usePlatformsAndSubjects({})

  const subjectId = useMemo(() => {
    if (!config || !selectedPlatform?.slug) {
      return null
    }

    return config.subjectIds[selectedPlatform.slug as PlatformSlug] ?? null
  }, [config, selectedPlatform?.slug])

  const renderTab = () => {
    const { title } = activeTab

    if (title === MockExamsTabs.FAQ && config?.faqPage) {
      return <FAQ page={config.faqPage} />
    }

    if (title === MockExamsTabs.Description && config?.descriptionPage) {
      return <DescriptionForm page={config.descriptionPage} />
    }

    if (!selectedPlatform?.id || !subjectId) {
      return null
    }

    return <CommonPTs platformId={selectedPlatform.id} subjectId={subjectId} type={type} />
  }

  if (!config) {
    return <NotFound />
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        {config.titleMultiple}
      </Typography>

      <TabsNavigation tabs={availableTabs} value={activeTab} onChange={setActiveTab} css={classes.tabs} />

      {renderTab()}
    </div>
  )
}
